import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

const ensureWalletFn = httpsCallable(functions, 'ensureWallet');
const buyCatalogTicketFn = httpsCallable(functions, 'buyCatalogTicket');
const createEcosystemAppointmentFn = httpsCallable(functions, 'createEcosystemAppointment');
const updateEcosystemAppointmentStatusFn = httpsCallable(
  functions,
  'updateEcosystemAppointmentStatus'
);
const patientUpdateEcosystemAppointmentFn = httpsCallable(
  functions,
  'patientUpdateEcosystemAppointment'
);
const markTicketPassAddedFn = httpsCallable(functions, 'markTicketPassAdded');
const adminSetUserRolesFn = httpsCallable(functions, 'adminSetUserRoles');

export async function ensureWallet(ownerFullName) {
  const { data } = await ensureWalletFn({ ownerFullName: ownerFullName || null });
  return data;
}

export async function buyCatalogTicket(payload) {
  const { data } = await buyCatalogTicketFn(payload);
  return data;
}

export async function createEcosystemAppointment(payload) {
  const { data } = await createEcosystemAppointmentFn(payload);
  return data;
}

export async function updateEcosystemAppointmentStatus(appointmentId, status) {
  const { data } = await updateEcosystemAppointmentStatusFn({ appointmentId, status });
  return data;
}

export async function patientUpdateEcosystemAppointment(payload) {
  const { data } = await patientUpdateEcosystemAppointmentFn(payload);
  return data;
}

export async function markTicketPassAdded(ticketId, platform) {
  const { data } = await markTicketPassAddedFn({ ticketId, platform });
  return data;
}

export async function adminSetUserRoles(userId, roles) {
  const { data } = await adminSetUserRolesFn({ userId, roles });
  return data;
}

const payHotelBookingDepositFn = httpsCallable(functions, 'payHotelBookingDeposit');

export async function payHotelBookingDeposit(bookingId) {
  const { data } = await payHotelBookingDepositFn({ bookingId });
  return data;
}
